/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Confirm_Deactivate_MsgInputs */



/**
* | output |
* | --- |
* | "This will deactivate the OAuth client. All tokens issued by this client will stop working." |
*
* @param {Developer_Confirm_Deactivate_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_confirm_deactivate_msg = /** @type {((inputs?: Developer_Confirm_Deactivate_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Confirm_Deactivate_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela désactivera le client OAuth. Tous les jetons émis par ce client cesseront de fonctionner.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto desactivará el cliente OAuth. Todos los tokens emitidos por este cliente dejarán de funcionar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Isso desativará o cliente OAuth. Todos os tokens emitidos por este cliente pararão de funcionar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo disattiverà il client OAuth. Tutti i token emessi da questo client smetteranno di funzionare.")
	return /** @type {LocalizedString} */ ("This will deactivate the OAuth client. All tokens issued by this client will stop working.")
});